import $ from 'jquery';

$(function () {
    const locationsSelects = $('.location-info-select');

    if (locationsSelects.length > 0) {
        locationsSelects.each((i, el) => {
            const locationInfos = $(el).siblings('.location-info-container').children('.location-info');
            $(el).on('change', function () {
                let val = $(this).val();
                
                locationInfos.each((i, el) => {
                    $(el).removeClass('show');
                    
                    if (val === $(el).attr('id'))
                        $(el).addClass('show');
                });
            });
        });
    }
});